import axios from 'axios';

export const BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://dev-gms-api.innoforest.co.kr';

const instance = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem('submitAccessToken');
    if (token) {
      config.headers['authorization'] = `${token}`;
    }
    config.baseURL = BASE_URL;
    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

export const getList = async (resource: string, params: any) => {
  try {
    const response = await instance.get(resource, {
      params,
    });
    return response.data;
  } catch (err: any) {
    return { isError: true, data: err.response?.data };
  }
};

export const getOne = async (resource: string, id?: string) => {
  try {
    const response = await instance.get(`${resource}/${id}`);
    return response.data;
  } catch (err: any) {
    return { isError: true, data: err.response?.data };
  }
};

export const create = async (resource: string, payload: any) => {
  try {
    const response = await instance.post(resource, { ...payload });
    return response.data;
  } catch (err: any) {
    return { isError: true, data: err.response?.data };
  }
};

export const update = async (resource: string, payload?: any) => {
  try {
    const response = await instance.put(resource, { ...payload });
    return response.data;
  } catch (err: any) {
    return { isError: true, data: err.response?.data };
  }
};

export const remove = async (resource: string, payload?: any) => {
  try {
    const response = await instance.delete(resource, { ...payload });
    return response.data;
  } catch (err: any) {
    return { isError: true, data: err.response?.data };
  }
};

export const upload = async (resource: string, params: any) => {
  try {
    const response = await instance.post(resource, params, {
      headers: {
        'Content-type':
          'multipart/form-data;charset=UTF-8; boundary=6o2knFse3p53ty9dmcQvWAIx1zInP11uCfbm',
        Accept: 'application/json',
      },
    });
    return response.data;
  } catch (err: any) {
    return { isError: true, data: err.response?.data };
  }
};

/** 파일 다운로드 (범용 함수) - submitAccessToken 사용 */
export const fileDownload = async (
  resource: string,
  params?: any,
  onProgress?: (progress: number) => void,
  fileName?: string
) => {
  try {
    const { data, headers } = await instance.get(resource, {
      responseType: 'blob',
      params,
      onDownloadProgress: (progressEvent) => {
        if (onProgress && progressEvent.total) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      },
    });

    const extractDownloadFilename = (headers: any) => {
      // 파일명이 인자로 전달되었으면 우선 사용
      if (fileName) {
        return fileName;
      }

      const disposition = headers['content-disposition'];
      if (!disposition) {
        // content-disposition 헤더가 없으면 기본 파일명 사용
        return 'download';
      }

      const extractedFileName = decodeURI(
        disposition
          .match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)?.[1]
          ?.replace(/['"]/g, '')
          .replace('UTF-8', '') || 'download'
      );

      return extractedFileName;
    };

    const blob = new Blob([data], {
      type: headers['content-type'] || 'application/octet-stream',
    });

    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = extractDownloadFilename(headers);
    link.click();
    URL.revokeObjectURL(blobUrl);
  } catch (err: any) {
    return Promise.reject(err);
  }
};
